import { render } from "./MenuJeu.vue?vue&type=template&id=f3de5374&scoped=true"
import script from "./MenuJeu.vue?vue&type=script&lang=js"
export * from "./MenuJeu.vue?vue&type=script&lang=js"

import "./MenuJeu.vue?vue&type=style&index=0&id=f3de5374&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3de5374"]])

export default __exports__